import { Text } from './Text';
import type { ComponentProps } from 'react';

type TextBaseProps = Omit<ComponentProps<typeof Text>, 'variant'> & {
    large?: boolean;
};

export const Paragraph = ({ large = false, ...props }: TextBaseProps) => {
    return <Text variant={large ? 'pLarge' : 'p'} {...props} />;
};
